import React, { useState } from "react";
import FormInput from "../form/FormInput";
import FormButton from "../form/FormButton";
import { useParams } from "react-router-dom";

import SelectInput from "../form/SelectInput";
import { handleToast } from "../../utils/functions";
import useInviteTeacherBySchool from "../../api/invitation/useInviteTeacherBySchool";

export default function NewAdmin() {
    const { schoolId } = useParams();

    const [email, setEmail] = useState("");
    const [role, setRole] = useState("");
    const { request, loading } = useInviteTeacherBySchool();

    async function sendInvite() {
        if (!email) return handleToast("Email address is required");
        if (!role) return handleToast("Role is required");
        await request({ email, role, type: "SCHOOL_ADMIN" }, schoolId);
    }

    return (
        <div>
            <h1 className="side_page_title">Invite Admin</h1>

            {/* <h2 className="text-lg text-black font-semibold">Invite Teacher</h2> */}
            <p className="text-dark_electric_blue text-sm">
                Invite a user to your school to collaborate in your workspace
            </p>

            <div className="max-w-md my-10">
                <FormInput
                    placeholder={"Enter user email"}
                    required
                    onChange={(e) => setEmail(e.currentTarget.value)}
                    value={email}
                />

                <SelectInput
                    placeholder="Role"
                    required
                    handleSelect={(e) => setRole(e.currentTarget.value)}
                    options={[
                        { name: "Principal", value: "PRINCIPAL" },
                        {
                            name: "Vice Principal Admin",
                            value: "VICE_PRINCIPAL_ADMIN",
                        },
                        {
                            name: "Vice Principal Academics",
                            value: "VICE_PRINCIPAL_ACADEMICS",
                        },
                        {
                            name: "Dean of studies/Exam Officer",
                            value: "EXAMS_OFFICER",
                        },
                        {
                            name: "Bursar",
                            value: "BURSAR",
                        },
                    ]}
                />

                <FormButton
                    title={"Send invite"}
                    onClick={sendInvite}
                    loading={loading}
                />
            </div>
        </div>
    );
}
